module.exports = __webpack_public_path__ + "img/7house02.16ccd064.jpg";